"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.activeOrderStatuses = exports.authProxyUrls = exports.callCenterUrls = exports.integrationApiUrls = void 0;
var api_1 = require("./types/api");
exports.integrationApiUrls = {
    estimate: 'orders/estimate',
    search: 'orders/search',
    payments: 'paymentmethods',
    tariffDescription: 'zonaltariffdescription',
    zoneInfo: 'zoneinfo',
    draft: 'orders/draft',
    commit: 'orders/commit',
    cancel: 'orders/cancel',
    suggest: 'suggest',
    changeDestinations: 'changedestinations',
    preOrder: 'preorder/avaliable',
    nearestZone: 'nearestzone',
    geoSearch: 'geosearch',
    nearestPosition: 'nearestposition',
    expectedPositions: 'expectedpositions',
    expectedDestinations: 'expecteddestinations',
    couponActivate: 'couponactivate',
    couponDeactivate: 'coupondeactivate',
    couponList: 'couponlist',
    historyList: '4.0/orderhistory/v2/list',
    historyItem: '4.0/orderhistory/v2/item',
    receipts: '4.0/ridehistory/v2/receipts',
    localitySuggest: '4.0/persuggest/v1/suggest-locality',
};
exports.callCenterUrls = __assign(__assign({}, exports.integrationApiUrls), { profile: 'profile' });
exports.authProxyUrls = __assign(__assign({}, exports.integrationApiUrls), { token: 'csrf_token', startup: '4.0/startup' });
exports.activeOrderStatuses = [
    api_1.OrderStatus.SEARCH,
    api_1.OrderStatus.TRANSPORTING,
    api_1.OrderStatus.DRIVING,
    api_1.OrderStatus.WAITING,
    api_1.OrderStatus.SCHEDULING,
];
